import { render, staticRenderFns } from "./StorageBrowserLookup.vue?vue&type=template&id=2a12d9d6&"
import script from "./StorageBrowserLookup.vue?vue&type=script&lang=ts&"
export * from "./StorageBrowserLookup.vue?vue&type=script&lang=ts&"
import style0 from "./StorageBrowserLookup.vue?vue&type=style&index=0&id=2a12d9d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports